import styled from "styled-components";

export const StyledImgWrapper = styled.div`
    min-height: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    video {
        display: block;
        height: 100%;
        width: auto;
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
        border-radius: 8px;
    }
`;
